"use client"

import style from "@/styles/global/not-found.module.scss";
import Link from "next/link";
import Image from "next/image";
import { Button } from "react-vant";
import NotFoundLoadMore from "@/components/global/NotFoundLoadMore";

export default function NotFound() {
  return (
    <div className={style["page-not-found"]}>
      <Image
        src={`${process.env.IMAGE_DOMAIN}/svg/icon-page-not-found.svg`}
        width={293}
        height={165}
        className={style["not-found-icon"]}
        alt="page-not-found"
      ></Image>
      
      <div className={style["title"]}>
        OH NO!
      </div>

      <div className={style["sub-title"]}>
        Sorry, this item is no longer available.<br></br>
        Please explore similar products you might like.
      </div>

      <Link href="/">
        <Button
          type="primary"
          className={style['continue-btn']}
          style={{ 
            fontWeight: "700",
            margin: '0 auto 20px auto'
          }}
          block
        >
          Continue Shopping
        </Button>
      </Link>

      <NotFoundLoadMore />
    </div>
  );
}
